module.exports = __webpack_public_path__ + "img/Webpay_FB_300px.eb2f57a0.png";